import styles from "./DataTableLayout.module.css";

const DataTableLayout = ({ title, stats, filters, actions, children }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>

      {stats && <div className={styles.stats}>{stats}</div>}

      <div className={styles.controls}>
        <div className={styles.filters}>{filters}</div>
        <div className={styles.actions}>{actions}</div>
      </div>

      <div className={styles.card}>{children}</div>
    </div>
  );
};

export default DataTableLayout;

